// @flow
import React from 'react';

import styled from 'styled-components';
import { fontFamily } from 'styled-system';

import BaseButton from '@waglabs/button';

type Props = {};

/**
 * TODO: We won't need to wrap this inside `styled` once
 * https://github.com/waglabs/wag-react/pull/107
 * has been released and `@waglabs/button` has been updated.
 * We also need to update `@waglabs/webapp-theme`.
 */
export const Button = styled<Props>(
  (props: Props) => (
    <BaseButton
      {...props}
    />
  ),
)`
  ${fontFamily}
`;

Button.defaultProps = {
  border: 0,
  borderRadius: 3,
  height: 40,
  lineHeight: 1,
  px: 3,
  // TODO: Add default `py` value
  width: [260, 212, 260],
};
